import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
export var FormBase = function (props) {
    var initial = props.initial, children = props.children;
    return (React.createElement(RampWithNameTransform, { rampName: "ContextContainer", initial: initial },
        React.createElement(RampWithNameTransform, { rampName: "Container" }, children)));
};
